// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".el-form-item--mini.el-form-item[data-v-f15eb900] {\n  margin-bottom: 5px;\n}", ""]);
// Exports
module.exports = exports;
